import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { getImidServiceUrl } from "utils/api-util";
import closeIcon from "../../assets/images/imageIcon/img_close.svg";
import { ClipLoader } from "react-spinners";
import GenerateBillSummary from "modals/GenerateBillSummary";

const GenerateBillModal = ({
  isOpen,
  selectDate,
  onClose,
  onConfirm,
  openBillGenerateBillModalResponse,
  numberOfUnit,
  setIsDateSelected,
  buildings,
  setErrorMsg,
  errMsg,
  isDateSelected,
  billingDate,
  setBillingDate,
  isChecked,
  state,
  setIsChecked,
  sendInvoiceOption,
  setSendInvoiceOption,
}) => {
  const navigate = useNavigate();

  const [billingInfo, setBillingInfo] = useState(null);
  const baseUrl = getImidServiceUrl();

  const [proceed, setProceed] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    if (!isDateSelected) {
      setBillingDate("");
    }
  }, [isDateSelected]);

  const [loading, setLoading] = useState(false);
  const [err, setError] = useState(null);

  const { id } = useParams();
  if (!isOpen) return null;

  const transformArray = (array) => {
    return array.map(({ apartmentNumber }) => {
      // Retain 'name' and 'city', and add new properties
      return {
        apartmentNumber, // Original 'apartmentnumber
        buildingId: id, // New property
        commonAreaPercentage: 0, // Another new property
      };
    });
  };

  const apartmentBillRequests = transformArray(buildings);

  const data = {
    totalConsumption: 0,
    useStoredBillingDate: isChecked,
    sendInvoice: sendInvoiceOption,
    billingDate,
    // tariff: 0,
    apartmentBillRequests,
  };

  const token = window.localStorage.getItem("token");

  const handleSubmit = async () => {
    setLoading(true);
    const url = `${baseUrl}/bills/generate/bulk`;

    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };

    try {
      // const res = await axios.post(url, data, { headers });
      const res = await fetch(url, {
        method: "POST",
        headers,
        body: JSON.stringify(data),
      });
      const fetchedData = await res.json();
      console.log(fetchedData);

      if (res.ok) {
        localStorage.setItem(
          "generateBillResponse",
          JSON.stringify(fetchedData)
        );
        // if successful, open response modal
        openBillGenerateBillModalResponse();
      } else {
        // setError("Error sending Data");
        console.log("Something went wrong");
      }
    } catch (err) {
      console.log(err);
      setError(err.message);
      setErrorMsg("Something went wrong");
    } finally {
      setLoading(false); // Reset loading to false when login action is completed
    }
  };

  // open bill sum,mary modal
  const opengenerateBillSummary = () => {
    if (!billingDate) {
      setErrorMsg("Please select a date before you can proceed");
      return;
    }
    setErrorMsg("");
    setProceed(true);
  };

  const closegenerateBillSummary = () => {
    setProceed(false);
  };

  // close modal
  const closeModal = () => {
    onClose();
    setIsDateSelected(false);
    setErrorMsg("");
    setBillingDate("");
    setIsChecked(false);
    closegenerateBillSummary();
    setErrorMessage("");
  };

  const selectBillingDate = (date) => {
    const selectedDate = date?.split("T")[0] || null;

    const isInvalidDate = buildings.some((building) => {
      const lastBillDate = building.lastBillGeneratedDate?.split("T")[0];
      if (!lastBillDate || !selectedDate) return false;

      return new Date(selectedDate) <= new Date(lastBillDate);
    });

    if (isInvalidDate) {
      setErrorMessage("Invalid billing date");
      return;
    }

    setErrorMessage(""); // clear error if date is valid
    selectDate(selectedDate);
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center z-0 bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-[30rem]">
        <div
          className="mb-2 cursor-pointer justify-end flex items-center"
          onClick={closeModal}
        >
          <img className=" mr-1" src={closeIcon} alt="close" />
        </div>
        {proceed ? (
          <GenerateBillSummary
            loading={loading}
            sendInvoiceOption={sendInvoiceOption}
            billingDate={billingDate}
            onClose={closegenerateBillSummary}
            handleSubmit={handleSubmit}
            numberOfUnit={numberOfUnit}
            buildings={buildings}
          />
        ) : (
          <div>
            <h2 className="text-xl font-extrabold mb-4 text-center text-[#4F4F4F]">
              Generate bill for the building number: {numberOfUnit}
            </h2>

            <p>Select Billing Date</p>
            <input
              onChange={(e) => selectBillingDate(e.target.value)}
              type="date"
              value={billingDate}
              className="w-full my-3"
            />
            {errorMessage && (
              <p className="text-red-500 text-sm mt-2">{errorMessage}</p>
            )}

            <div className="w-full  mt-4">
              <div>
                <input
                  type="checkbox"
                  id="check"
                  checked={isChecked}
                  onChange={(e) => setIsChecked(e.target.checked)}
                />
                <label htmlFor="check" className="ml-2">
                  Use stored billing date
                </label>
              </div>
              <div className="mt-4">
                <p className="mb-2 font-medium">Send Invoice Option:</p>
                <label className="flex items-center mb-2">
                  <input
                    type="radio"
                    value="NO_INVOICE"
                    checked={sendInvoiceOption === "NO_INVOICE"}
                    onChange={(e) => setSendInvoiceOption(e.target.value)}
                  />
                  <span className="ml-2">No Invoice</span>
                </label>
                <label className="flex items-center mb-2">
                  <input
                    type="radio"
                    value="MONTHLY"
                    checked={sendInvoiceOption === "MONTHLY"}
                    onChange={(e) => setSendInvoiceOption(e.target.value)}
                  />
                  <span className="ml-2">Monthly</span>
                </label>
                <label className="flex items-center">
                  <input
                    type="radio"
                    value="BI_MONTHLY"
                    checked={sendInvoiceOption === "BI_MONTHLY"}
                    onChange={(e) => setSendInvoiceOption(e.target.value)}
                  />
                  <span className="ml-2">Bi-monthly</span>
                </label>
              </div>
              <div className="flex mt-3 justify-center space-x-4">
                <button
                  className="px-4 py-2 bg-[#fff] text-[12px] border border-[#0074bb] text-[#0074bb] rounded hover:bg-[#dad5d54e]"
                  onClick={opengenerateBillSummary}
                  disabled={errorMessage}
                >
                  Generate bill without common area
                </button>

                <button
                  className="px-4 py-2 bg-[#0074bb] text-[12px] text-[#fff] rounded hover:bg-[#0054bb]"
                  onClick={onConfirm}
                  disabled={errorMessage}
                >
                  Generate bill with common area
                </button>
              </div>
            </div>
          </div>
        )}
        <p className="text-red-500 text-[10px] my-3 ">{errMsg}</p>
      </div>
    </div>
  );
};

GenerateBillModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default GenerateBillModal;
